module.exports = __webpack_public_path__ + "static/img/18_巴士即時動態.722999c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/button/18_巴士即時動態.png
// module id = 9GtR
// module chunks = 1